module.exports = __webpack_public_path__ + "static/img/celoscope-11.d871a77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-11.jpg
// module id = JMKf
// module chunks = 52